import { css } from '@emotion/react'
import { Color, Size, Spacing, Theme, Transition } from '@opallabs/gem'

export const userMenu = css({
  alignItems: 'center',
  blockSize: '100%',
  display: 'flex',

  'button + .user-menu-item': {
    marginInlineStart: 12,
  },
})

export const userMenuItem = (theme: Theme) =>
  css({
    alignItems: 'center',
    borderRadius: Size.Rounding,
    color: Color[theme].Surface.N100,
    display: 'flex',
    justifyContent: 'center',
    minInlineSize: Spacing.XS * 9,
    ...Transition(['opacity']),

    '.kuiper-avatar-outer-wrapper': {
      borderWidth: 2,
    },
  })

export const userAvatar = css({
  fontSize: 14,
  fontWeight: 700,
  lineHeight: 1,
})
